var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.825 0-16 7.175-16 16s7.175 16 16 16 16-7.181 16-16-7.175-16-16-16zM16 29.519c-7.456 0-13.519-6.063-13.519-13.519s6.063-13.519 13.519-13.519 13.519 6.063 13.519 13.519-6.063 13.519-13.519 13.519z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.194 14.65h-4.956v-4.956c0-0.681-0.556-1.238-1.238-1.238s-1.238 0.556-1.238 1.238v4.956h-4.956c-0.688 0-1.238 0.556-1.238 1.238s0.556 1.238 1.238 1.238h4.956v4.956c0 0.681 0.556 1.238 1.238 1.238 0.688 0 1.238-0.556 1.238-1.238v-4.956h4.956c0.688 0 1.238-0.556 1.238-1.238s-0.55-1.238-1.238-1.238z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.93f1d7fb022dc12fa6d781df62910b19.svg";
export { ForwardRef as ReactComponent };